import React from 'react';
import { useRecoilValue } from 'recoil';
import { accountSelectedSelector } from 'atoms';
import { useGetCamerasListApi } from 'hooks';
import { Account } from 'types/Account';
import { Navigate, useSearchParams } from 'react-router-dom';
import EmptyState from 'components/EmptyState';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress } from '@mui/material';

function CamerasPage() {
  const accountSelected = useRecoilValue(accountSelectedSelector);
  if (!accountSelected) {
    return <Navigate to="/" />;
  }

  return <CamerasRedirect {...{ accountSelected }} />;
}

function CamerasRedirect({ accountSelected }: { accountSelected: Account }) {
  const { cameras, loading, error } = useGetCamerasListApi({ accountSelected });
  const { t } = useTranslation('_common');
  const [searchParams] = useSearchParams();

  if (loading) {
    return (
      <Box sx={{ mx: 'auto', textAlign: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    throw error;
  }

  if (!cameras || cameras.length === 0) {
    return <EmptyState title={t('there_is_still_nothing_here')} description="" />;
  }

  return <Navigate to={`/cameras/${cameras[0].name}?${searchParams.toString()}`} />;
}

export default CamerasPage;
